export default __webpack_public_path__ + "968405183f0230b72db40297a2464273.svg";